import { LazyPage } from '@/app/components'
import {
  LocationTag,
  pageWithErrorBoundary,
} from '@/authenticated/components/ErrorBoundary'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
const MassCleanPeak = React.lazy(
  () => import('./mass-clean-peak/mass-clean-peak'),
)
export default function SurveyCompletion() {
  return (
    <Switch>
      <Route
        path={'*/survey-completion/MassCleanPeak'}
        component={pageWithErrorBoundary(LazyPage(MassCleanPeak), {
          location: LocationTag.UtilityProgramSurveyCompletionMassCleanPeak,
          functionalityDescription:
            'Utility Program Survey Completion Massachusetts Clean Peak Page',
          severity: 'critical',
        })}
      />
    </Switch>
  )
}
